import { t } from 'i18next';

interface Props {
  title?: string;
  text?: string | null;
}

export const ErrorWrapper = ({ title, text }: Props) => {
  const getDetails = () => {
    const searchParams = new URL(window.location.href).searchParams;
    const details: Record<string, string>[] = [];

    searchParams.forEach((value, key) => details.push({ key: value }));

    return details;
  };

  return (
    <div className='error-container'>
      <div>
        <h5>{title}</h5>
        <p>{text}</p>
        {getDetails().map((detail) => (
          <div key={detail.key} className='error-details'>
            {detail.key}
          </div>
        ))}
      </div>
    </div>
  );
};

export const Forbidden = () => <ErrorWrapper title={t('ForbiddenTitle')} text={t('ForbiddenText')} />;
export const NotFound = () => <ErrorWrapper title={t('NotFoundTitle')} text={t('NotFoundText')} />;
export const ExpiredInvite = () => <ErrorWrapper title={t('ExpiredInviteTitle')} text={t('ExpiredInviteText')} />;
export const FailedInvite = () => <ErrorWrapper title={t('FailedInviteTitle')} text={t('FailedInviteText')} />;
